import { createRoot } from 'react-dom/client';
import { getMediaQuerySizesFromAttributes } from '@repo/common-utils/mediaQueryAttributeInputHelper';
import { getCsvAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import MemberCardProductGrid from './MemberCardProductGrid';

// Native member cards have no product-type vs product distinction, so both discovery element
// names (the counterparts of the two value-card discovery widgets) render the same product grid.
function defineMemberCardGrid(elementName: string): () => void {
    class BilberryMemberCardGrid extends BilberryCustomElement {
        protected renderWidget(): void {
            const ids = getCsvAttribute(this, 'member-card-product-ids');
            const urls = getCsvAttribute(this, 'member-card-product-urls');
            const numElements = getMediaQuerySizesFromAttributes(this, 1, 2, 3, 3);
            const scroll = (this.getAttribute('scroll') ?? '').toLowerCase() === 'yes';

            createRoot(this._mountPoint).render(
                <WidgetWrapper
                    mountPoint={this._mountPoint}
                    popoverMountPoint={this._popoverMountPoint}
                    shadowRoot={this._shadowRoot}
                >
                    <MemberCardProductGrid
                        ids={ids}
                        urls={urls}
                        numElements={numElements}
                        scroll={scroll}
                    />
                </WidgetWrapper>,
            );
        }
    }

    return () => customElements.define(elementName, BilberryMemberCardGrid);
}

export const MemberCardProductCardsWidget = defineMemberCardGrid(
    'bilberry-member-card-product-cards',
);
export const MemberCardProductItemCardsWidget = defineMemberCardGrid(
    'bilberry-member-card-product-item-cards',
);
